/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from 'graphql-tag';

export const GET_APPLICATION_DETAIL_DOFT = gql`
query GetApplicationById($applicationId: String) {
    getApplicationById(applicationId: $applicationId) {
        applicationType {
            isCitizen
        }
        givenName
        familyName
        dateOfBirth
        placeOfBirth
        island
        nationality
        province
        fatherName
        motherName
        maritalStatus
        employmentStatus
        applicationCurrentStatus
        uploadedReceiptURL
        appliedOn
        applicationId
        address {
            addressLine1
            addressLine2
            city
            state
            country
        }
        telephone
        passport {
            passportNo
            dateIssued
            expiredDate
            placeIssued
            passportCopyURL
        }
        birthCertificateCopyURL
        nonCitizenPOD {
            countryOfOrigin
            dateEntered
            statusInVanuatu
            portOfLastDisembark
            durBeginInVanuatuFrm
            durBeginInVanuatuTo
            occupation
            businessAddress {
                addressLine1
                addressLine2
                city
                state
                country
            }
            workPermitCopyURL
            confirmationLetterURL
            residentialPermitCopyURL
        }
        paymentReceipt {
            officer {
                email
                givenName
                familyName
                forceNo
                rank
                designation
                fullName
                telephone
            }
            familyName
            givenName
            receiptId
            transactionDate
            transactionAmount
            receiptCopyURL
        }
        applicationStatus {
            message
            officer {
              givenName
              fullName
              familyName
              email
              department
            }
          }
        assessment {
            officer {
                email
                givenName
                familyName
                fullName
                telephone
                forceNo
                rank
                designation
            }
            criminalRecords {
                offenseCommitted
                courtName
                sentense
                date
                recordCopyURL
            }
            comments
            updatedOn
        }
        certificate {
            CommissionerOfPolice
            certificateCopyURL
          }
    }
}
`;
